import { render, staticRenderFns } from "./BottomSheetUpload.vue?vue&type=template&id=2997adaa"
import script from "./BottomSheetUpload.vue?vue&type=script&lang=ts"
export * from "./BottomSheetUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports